import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'terminos-condiciones',
  templateUrl: './terminos-condiciones.component.html',
  styleUrls: ['./terminos-condiciones.component.css']
})
export class TerminosCondicionesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
